<template>
  <div class="card border-0 h-md-100" data-bs-theme="light"
       style="background: linear-gradient(112.14deg, #fe3533 0%, #fe7854 100%)">
    <!--begin::Body-->
    <div class="card-body">
      <!--begin::Row-->
      <div class="row align-items-center h-100">
        <div class="col-7" style="position: relative;">
          <div class="text-white pt-16;" style="position: absolute;top: 10px">
            <span class="fw-bold" style="font-size: 50px">{{ obj.webTitle }}欢迎你</span>
            <span class="fs-1 fw-semibold me-2 d-block lh-1 pb-2 opacity-75">打造生意的N种可能</span>
          </div>
          <span class="fw-semibold text-white mb-8 d-block" style="font-size: 20px">
<!--                    打造生意的N种可能-->
                </span>
          <div style="color: #fff;margin-bottom: 15px;margin-left: 5px;margin-top: 120px">常用工具</div>
          <div class="d-flex flex-column flex-sm-row d-grid gap-2">
            <!--            <a href="#" class="btn btn-success flex-shrink-0 me-lg-2" @click="$refs.Assistant.open()">上架小助手</a>-->
            <!--            暂未开放尽情期待-->

            <el-button round @click="no">一键导出商品</el-button>
          </div>
        </div>

        <div class="col-5 pt-10" style="margin-left: -20px">
          <div class="bgi-no-repeat bgi-size-contain bgi-position-x-end h-225px"
               style="background-image:url('https://sjzcsaas.oss-cn-hangzhou.aliyuncs.com/xingyunsi/1.5.21/%E7%BB%844.png')">
          </div>
        </div>
      </div>
    </div>
    <!--    上架小助手-->
    <ModalDialog ref="Assistant" title="上架小助手">
      <div class="row mb-2">
        <label class="col-lg-3 fw-bold text-muted" style="margin-top: 10px"
        >*京东商品链接:</label
        >
        <div class="col-lg-9">
          <input
              id="goodsUrl"
              name="goodsUrl"
              v-model="goodsUrl"
              class="form-control form-control-solid"
              placeholder="请输入商品链接"
          />
        </div>
        <!--end::Col-->
        <div class="separator separator-dashed my-2"></div>
      </div>
      <div class="row mb-2">
        <!--begin::Label-->
        <label class="fw-bold text-muted" style="margin-top: 10px"
               v-clipboard="'https://item.jd.com/100044924745.html'"
        >示例:https://item.jd.com/100044924745.html&nbsp;&nbsp;&nbsp;<span class="text-primary">点击复制</span></label
        >
        <!--end::Label-->
      </div>
      <!--begin::Input group-->
      <div class="row fv-row mb-7 fv-plugins-icon-container"></div>
      <div class="modal-footer">
        <button
            type="button"
            class="btn btn-light"
            @click="$refs.Assistant.close()"
        >
          关闭
        </button>
        <button type="button" class="btn btn-primary" @click="assistant">
          提交
        </button>
      </div>
    </ModalDialog>

  </div>
</template>
<script>

import {mapState} from "vuex";

export default {
  name: "Jumbotron",
  data() {
    return {
      goodsUrl: ''
    }
  },
  methods: {
    assistant() {
      if (this.goodsUrl == "") {
        this.$swal.fire({
          icon: "error",
          title: "请输入京东商品链接!",
          toast: true,
          position: "center",
          showConfirmButton: false,
          timer: 2000,
        });
        return;
      }
      let url = encodeURIComponent(this.goodsUrl);
      this.$router.push({
        name: "AddOrUpdateVisible",
        params: {id: url},
      });
    },
    no() {
      this.$router.push({ path: '/goods', query: { openExportTool: true }});
    }
  },
  computed: {
    ...mapState("web", ["obj"]),
  },
}
</script>
<style scoped>
.el-button {
  color: #FE4239 !important;
}
.el-button:hover{
  color: #FE4239 !important;
  border-color: #fecccc  !important;
  background-color: #fecccc  !important;
}
</style>
